import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useCurrentFormState } from '../../../../../../../../controllers/issue-adjustments/hooks/use-current-form-state';
import { useFormMetadata } from '../../../../../../../../controllers/issue-adjustments/hooks/use-form-metadata';
import { useViewType } from '../../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { UiModificationsFieldsValidationError } from '../../../../../../../../controllers/issue-adjustments/utils/errors/ui-modifications-field-validation-error';
import { validateFieldChanges } from './validate-field-changes';
var filterInvalidResults = function filterInvalidResults(results) {
  return results.reduce(function (acc, result) {
    if (result.isValid === false) {
      acc.push(result);
    }
    return acc;
  }, []);
};
var mapValidResultsToFieldChangesMap = function mapValidResultsToFieldChangesMap(results) {
  return results.reduce(function (acc, result) {
    if (result.isValid === true) {
      var _result$data = result.data,
        fieldId = _result$data.fieldId,
        fieldData = _result$data.fieldData;
      acc[fieldId] = fieldData;
    }
    return acc;
  }, {});
};
export var useFieldsChangesValidation = function useFieldsChangesValidation() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var formMetadata = useFormMetadata();
  var formMetadataRef = useRef(formMetadata);
  var viewType = useViewType();
  var _useCurrentFormState = useCurrentFormState(),
    currentFormState = _useCurrentFormState.currentFormState;
  var currentFormStateRef = useRef(currentFormState);

  /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */
  formMetadataRef.current = formMetadata;
  currentFormStateRef.current = currentFormState;
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fieldsChanges) {
      var fieldsChangesValidationResult, failedValidationResults;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(Object.entries(fieldsChanges).filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 1),
                fieldId = _ref3[0];
              return formMetadataRef.current[fieldId] !== undefined;
            }).map( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
                var _ref6, fieldId, fieldData, fieldType, fieldValidationResult;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _ref6 = _slicedToArray(_ref4, 2), fieldId = _ref6[0], fieldData = _ref6[1];
                      fieldType = formMetadataRef.current[fieldId].fieldType;
                      _context.next = 4;
                      return validateFieldChanges({
                        fieldType: fieldType,
                        fieldId: fieldId,
                        viewType: viewType,
                        createAnalyticsEvent: createAnalyticsEvent,
                        fieldMetadata: formMetadataRef.current[fieldId],
                        currentField: currentFormStateRef.current[fieldId],
                        fieldFromIframe: fieldData
                      });
                    case 4:
                      fieldValidationResult = _context.sent;
                      if (!(fieldValidationResult.isValid === false)) {
                        _context.next = 7;
                        break;
                      }
                      return _context.abrupt("return", fieldValidationResult);
                    case 7:
                      return _context.abrupt("return", _objectSpread(_objectSpread({}, fieldValidationResult), {}, {
                        data: {
                          fieldId: fieldId,
                          fieldData: fieldData
                        }
                      }));
                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }()));
          case 2:
            fieldsChangesValidationResult = _context2.sent;
            failedValidationResults = filterInvalidResults(fieldsChangesValidationResult);
            if (!failedValidationResults.length) {
              _context2.next = 6;
              break;
            }
            throw new UiModificationsFieldsValidationError('Validation failed', {
              errors: failedValidationResults.flatMap(function (result) {
                return result.errors;
              })
            });
          case 6:
            return _context2.abrupt("return", mapValidResultsToFieldChangesMap(fieldsChangesValidationResult));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [createAnalyticsEvent, viewType]);
};